import {CtPage} from './ct-page';
import {Language} from './language';

import {construct, createInstance, ModelProperties} from '../utils';

export class CtPageUrl {
    id!: number;

    pageId!: number;

    languageId!: number;

    route!: string;

    enabled!: boolean;

    published!: boolean;

    page?: CtPage;

    language?: Language;

    outdated?: boolean;

    constructor(url?: ModelProperties<CtPageUrl>) {
        if (url) {
            construct(this, url);
            this.page = createInstance(CtPage, url.page);
            this.language = createInstance(Language, url.language);
        }
    }
}